import React from 'react';
import { Button as MuiButton, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  onClick: PropTypes.func,
};
const defaultProps = {
  disabled: undefined,
  type: undefined,
  onClick: undefined,
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#9c27b0',
    borderRadius: '8px',
    color: '#FFFFFF',
    fontSize: '14px',
    fontWeight: '500',
    height: '34px',
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    textTransform: 'capitalize',
    '&:hover': { backgroundColor: '#9c27b0' },
  },
  disabled: {
    backgroundColor: '#CCD0D3',
    color: '#707171',
    fontStyle: 'italic',
  },
}));

function Button({ children, disabled, type, onClick }) {
  const classes = useStyles();

  return (
    <MuiButton
      classes={{ root: classes.root, disabled: classes.disabled }}
      disabled={disabled}
      type={type}
      variant="contained"
      onClick={onClick}
    >
      {children}
    </MuiButton>
  );
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
